import React from 'react';
import { GiFairyWings } from 'react-icons/gi';
import { Helmet } from "react-helmet-async";
import './Refund.css';

const Refund = () => {
  return (
    <>
      <Helmet>
        <title>Refund & Cancellation Policy | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Refund and cancellation policy for Rajput Shiksha Kosh, outlining the terms and conditions for refunds and cancellations."
        />
      </Helmet>
    <section className="refund-and-cancellation-wrapper">
      <div className="refund-and-cancellation-container">
        
        {/* --- 1. HEADER (Title + Divider) --- */}
        <div className="refund-and-cancellation-header">
          <h2 className="refund-and-cancellation-title">REFUND & CANCELLATION</h2>
          <div className="refund-and-cancellation-divider">
            <span className="refund-and-cancellation-line"></span>
            <GiFairyWings className="refund-and-cancellation-icon" />
            <span className="refund-and-cancellation-line"></span>
          </div>
        </div>

        {/* --- 2. MAIN CONTENT DIV (White Background Card) --- */}
        <div className="refund-and-cancellation-content-card">
          
          <h3 className="refund-and-cancellation-sub-heading-line">
            राजपूत शिक्षा कोष - रिफंड एवं रद्दीकरण नीति
          </h3>
          
          <p className="refund-and-cancellation-paragraph">
            <strong>राजपूत शिक्षा कोष</strong> में आपका सहयोग समाज के अभावग्रस्त और प्रतिभावान बच्चों के भविष्य को उज्ज्वल बनाने के लिए अत्यंत महत्वपूर्ण है। एक गैर-लाभकारी (Non-Profit) और धर्मार्थ ट्रस्ट होने के नाते, हमारे द्वारा प्राप्त किए गए दान (Donation) को समाज हित में स्थायी कोष (Corpus Fund) में जमा किया जाता है। इसलिए, हमारी रिफंड और रद्दीकरण नीति निम्नलिखित है:
          </p>

          <h4 className="refund-and-cancellation-section-title">1. सामान्य दान रिफंड (General Donation Refund)</h4>
          <ul className="refund-and-cancellation-list">
            <li>राजपूत शिक्षा कोष में दिया गया कोई भी दान पूर्णतः स्वैच्छिक (Voluntary) है।</li>
            <li>एक बार दान सफलतापूर्वक प्राप्त हो जाने और उसकी रसीद (Receipt) जारी हो जाने के बाद, <strong>किसी भी परिस्थिति में दान की गई राशि वापस (Refund) नहीं की जाएगी।</strong></li>
            <li>हम सभी दाताओं से अनुरोध करते हैं कि वे भुगतान करने से पहले दान की जाने वाली राशि की भली-भांति पुष्टि कर लें।</li>
          </ul>

          <h4 className="refund-and-cancellation-section-title">2. तकनीकी त्रुटि या दोहरा भुगतान (Technical Error & Double Payment)</h4>
          <p className="refund-and-cancellation-paragraph">
            यदि पेमेंट गेटवे, नेटवर्क या सर्वर की किसी तकनीकी समस्या के कारण आपके बैंक खाते से पैसे कट गए हैं, लेकिन आपको रसीद प्राप्त नहीं हुई है, या गलती से एक ही लेन-देन के लिए <strong>दो बार भुगतान (Double Deduction)</strong> हो गया है, तो ऐसी स्थिति में:
          </p>
          <ul className="refund-and-cancellation-list">
            <li>आपको भुगतान की तिथि से <strong>7 दिनों के भीतर</strong> हमसे संपर्क करना होगा।</li>
            <li>संपर्क करते समय आपको अपने भुगतान का प्रमाण (जैसे- बैंक स्टेटमेंट, ट्रांजेक्शन आईडी या मैसेज का स्क्रीनशॉट) हमें ईमेल करना होगा।</li>
            <li>हमारी टीम मामले की जाँच करेगी और यदि आपका दावा सही पाया जाता है, तो अतिरिक्त काटी गई राशि आपके उसी बैंक खाते में <strong>10 से 15 कार्य दिवसों (Working Days)</strong> के भीतर रिफंड कर दी जाएगी।</li>
          </ul>

          <h4 className="refund-and-cancellation-section-title">3. प्रतिभा खोज परीक्षा (Pratibha Khoj Pariksha) या अन्य आवेदन शुल्क</h4>
          <ul className="refund-and-cancellation-list">
            <li>यदि किसी छात्र द्वारा परीक्षा फॉर्म या किसी अन्य शैक्षणिक आवेदन के लिए कोई शुल्क जमा किया गया है, तो वह शुल्क वापस (Non-Refundable) नहीं होगा।</li>
            <li>यदि किसी अपरिहार्य कारणवश ट्रस्ट द्वारा परीक्षा या कार्यक्रम रद्द (Cancel) किया जाता है, तो शुल्क वापसी का निर्णय प्रबंध समिति (Trustee Board) द्वारा लिया जाएगा और इसकी सूचना वेबसाइट पर दी जाएगी।</li>
          </ul>

          <h4 className="refund-and-cancellation-section-title">4. रिफंड के लिए कैसे संपर्क करें?</h4>
          <p className="refund-and-cancellation-paragraph">
            तकनीकी त्रुटि से संबंधित रिफंड का अनुरोध करने के लिए, कृपया निम्नलिखित विवरणों के साथ हमें ईमेल करें:
            <br />
            1. दानदाता / छात्र का नाम
            <br />
            2. पंजीकृत मोबाइल नंबर
            <br />
            3. ट्रांजेक्शन तिथि और राशि
            <br />
            4. बैंक खाते से पैसे कटने का स्क्रीनशॉट या ट्रांजेक्शन आईडी
          </p>

          <p className="refund-and-cancellation-blessing">
            समाज के उत्थान हेतु आपके उदार सहयोग और विश्वास के लिए हम आपके आभारी हैं।
          </p>

          {/* --- SIGNATURE / CONTACT INFO --- */}
          <div className="refund-and-cancellation-footer-sig">
            <h4>राजपूत शिक्षा कोष</h4>
            <p><strong>रिफंड एवं सहायता संपर्क:</strong></p>
            <p><strong>ईमेल:</strong> rajputshikshakosh@gmail.com</p>
            <p><strong>कार्यालय:</strong> मारवाड़ राजपूत सभा भवन, पावटा 'बी' रोड, जोधपुर (राज.)</p>
          </div>
        </div>

      </div>
    </section>
    </>
  );
};

export default Refund;